"use strict";

Shopify.theme.jsCollectionTabs = {
  init: function init($section) {

    var slider = $('[data-collection-tabs-slider]');

    if ($(window).width() < 800) {
    this.createSlider(slider);
    }
    this.customTabs();
  },
  customTabs:function customTabs(){

    $(document).on('click', '.tabs-nav_custom button', function(event) {
      event.preventDefault();

      let currentTab = $(this).data('target');

      // Check for active
      $('.tabs-nav_custom span').not(currentTab).removeClass('active');
      $(`[data-target="${currentTab}"]`).closest('span').addClass('active');

      // Display active tab

      $('.tabs-content div').removeClass('tab_show');
      $(currentTab).addClass('tab_show');

      $('.flickity-enabled', currentTab).flickity('resize');

      return false;
    });
    // init active
    $('.tabs-nav_custom span:first button').click();

    },
  createSlider: function createSlider(slider) {
    var $collectionTabs = slider.flickity({
      initialIndex: 0,
      prevNextButtons: true,
      pageDots: false,
      cellAlign: 'left',
      arrowShape: window.arrowShape,
    }); // Reset layout to avoid collapsing issues

    setTimeout(function () {
      $collectionTabs.flickity('resize');
    }, 500);

    // setTimeout(function () {
    //     //   $collectionTabs.flickity('resize');
    //     // }, 500);
    //     // $('body').on('click', '', function () {
    //     //   $collectionTabs.flickity('previous');
    //     // });
    //     // $('body').on('click', '', function () {
    //     //   $collectionTabs.flickity('next');
    //     // });
  }
};
